"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Root = exports.CarouselWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
  margin: theme.spacing(3, 0),
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(10),
    margin: theme.spacing(8, 0)
  }
}));
const CarouselWrapper = exports.CarouselWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  renderOnMyPages,
  carouselWidth
}) => ({
  maxWidth: '100%',
  width: carouselWidth,
  [theme.breakpoints.up('sm')]: {
    maxWidth: `min(${renderOnMyPages ? 640 : 822}px, 100%)` // 4 slides
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: `min(${renderOnMyPages ? 640 : 1004}px, 100%)` // 5 slides
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: `min(${renderOnMyPages ? 822 : 1186}px, 100%)` // 6 slides
  }
}));
const Title = exports.Title = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  margin: theme.spacing(0, 3),
  [theme.breakpoints.up('sm')]: {
    margin: 0
  }
}));
